import React from "react"
import Button from "../../../components/Button/Button"
import {Modal} from "../../../components/Modals/Modal"

interface ThemeSuccessModalProps {
	close: () => void
	onDownloadThemeButtonClick: () => void
}

export function ThemeSuccessModal({close, onDownloadThemeButtonClick}: ThemeSuccessModalProps) {
	return (
		<Modal enableClickAway={false} close={close} classname="theme-success-modal-container">
			<div className="theme-success-modal">
				<h2 className="modal-title">Theme changes were saved successfully</h2>
				<p className="modal-description">
					In order to see these changes live, you can click{" "}
					<a href="#" onClick={onDownloadThemeButtonClick}>
						Download Theme
					</a>{" "}
					and forward the code snippet to your Unit CSM.
				</p>
				<div className="action-buttons">
					<Button type="button" onClick={close} className="action-button" theme="neutral" variant="outline" rounded>
						Got it
					</Button>
				</div>
			</div>
		</Modal>
	)
}
